(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-luxury-guide]').forEach(root => {
      if (root.dataset.boutiqueControlsReady) return;
      const cards = [...root.querySelectorAll('[data-luxury-product]')];
      const grid = root.querySelector('[data-luxury-comparison-grid]');
      const status = root.querySelector('[data-luxury-compare-status]');
      if (!cards.length || !grid || !status) return;
      root.dataset.boutiqueControlsReady = 'true';
      root.querySelectorAll('[data-luxury-enhanced]').forEach(node => { node.hidden = false; });
      const selected = new Set();
      let band = 'all';
      const renderComparison = () => {
        grid.replaceChildren();
        if (selected.size >= 2) {
          cards.filter(card => selected.has(card.dataset.luxuryProduct)).forEach(card => {
            grid.append(card.querySelector('[data-luxury-comparison-template]').content.cloneNode(true));
          });
        }
        grid.style.setProperty('--compare-columns', String(Math.max(2, selected.size)));
        status.textContent = selected.size < 2 ? status.dataset.empty : '';
        cards.forEach(card => { card.querySelector('[data-luxury-compare]').checked = selected.has(card.dataset.luxuryProduct); });
      };
      const applyBudget = () => {
        const kind = root.querySelector('[data-luxury-pick][aria-current=true]')?.dataset.luxuryPick;
        cards.forEach(card => {
          const price = Number(card.dataset.luxuryPrice);
          const inBand = band === 'all' || (band === 'entry' && price < 10000) || (band === 'signature' && price >= 10000 && price < 25000) || (band === 'ultimate' && price >= 25000);
          card.hidden = !inBand || Boolean(kind && card.dataset.luxuryKind !== kind);
        });
        const count = cards.filter(card => !card.hidden).length;
        root.dataset.luxuryCount = String(count);
        root.querySelector('[data-luxury-budget-empty]').hidden = count > 0;
      };
      root.addEventListener('change', event => {
        const checkbox = event.target.closest('[data-luxury-compare]');
        if (!checkbox) return;
        if (checkbox.checked && selected.size >= 3) { checkbox.checked = false; status.textContent = status.dataset.limit; return; }
        if (checkbox.checked) selected.add(checkbox.value); else selected.delete(checkbox.value);
        renderComparison();
      });
      root.addEventListener('click', event => {
        const remove = event.target.closest('[data-luxury-compare-remove]');
        if (remove) {
          selected.delete(remove.dataset.luxuryCompareRemove);
          const checkbox = cards.find(card => card.dataset.luxuryProduct === remove.dataset.luxuryCompareRemove)?.querySelector('[data-luxury-compare]');
          renderComparison();
          if (checkbox && !checkbox.closest('[hidden]')) checkbox.focus({preventScroll:true});
          else {
            const heading = root.querySelector('.luxe-comparator h2');
            heading.setAttribute('tabindex','-1');
            heading.focus({preventScroll:true});
          }
          return;
        }
        const budget = event.target.closest('[data-luxury-budget]');
        if (budget) {
          band = budget.dataset.luxuryBudget;
          root.querySelectorAll('[data-luxury-budget]').forEach(button => button.setAttribute('aria-pressed', String(button === budget)));
          applyBudget();
        } else if (event.target.closest('[data-luxury-pick], [data-luxury-reset]')) {
          // Run after the existing category handler; retain a combined filter.
          queueMicrotask(applyBudget);
        }
      });
    });
  };
  initialize();
  if (!window.kkareBoutiqueControlsBound) {
    window.kkareBoutiqueControlsBound = true;
    document.addEventListener('shopify:section:load', event => initialize(event.target));
  }
})();
